"use client";

import type { ReactNode } from "react";
import { cn } from "../../lib";

export interface MediaPlayerReadingPaceControlProps {
	children: ReactNode;
	className?: string;
}

/** Slot wrapper for topic reading-pace UI (Zap HUD or wide slider host). */
export function MediaPlayerReadingPaceControl({
	children,
	className,
}: MediaPlayerReadingPaceControlProps) {
	return (
		<div className={cn("flex shrink-0 items-center", className)}>
			{children}
		</div>
	);
}
